import { observable, action, makeObservable } from "mobx";

export default class NotificationError {
  constructor({ name, retryFunc }) {
    makeObservable(this, {
      isLoading: observable,
      retry: action,
    });

    this.name = name;
    this.retryFunc = retryFunc;
  }

  isLoading = false;

  retry() {
    this.isLoading = true;
    this.retryFunc();
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  }
}
